import React from "react";
import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import ScrollToTop from "../../../../common/cards/ScrollToTop";
import { PROFILE } from "../../../../Store/Features/ProfileSlice";
import DiscussionPanel from "./DiscussionPanel";
import { ROLES } from "../../../../Config/helpers/constants";
import { SideBar } from "../../../../common/leftsidebar";

function Home() {
  const userDetails = useSelector(PROFILE);
  return (
    <Row justify="center" gutter={[20, 0]} className="rowPadding">
      <ScrollToTop />
      <SideBar
        noExploreEvents
        eventHistoryLInk={`/view/panel/${userDetails?._id}/eventhistory`}
        current={ROLES.panel}
      />
      <Col xs={24} sm={24} md={24} lg={14}>
        {userDetails?._id ? <DiscussionPanel /> : null}
      </Col>
    </Row>
  );
}

export default Home;
